import { service } from "node-back-client/src/services/api";
import { apiService } from "./apiService";
// import { faqService } from "./faq";

let apis = {};
let isCalled = false;
let url = process.env.VUE_APP_REGION_URL;


async function getRegions() {
    if (isCalled) {
        return apis;
    }

    let serv = service(url, "RegionServers");
    let regions = await serv.get("");

    regions.forEach(region => {
        apis[region.countryCode] = new apiService(region.url);
    });
    return apis;
}

async function getProducts() {
    if (isCalled) {
        return apis;
    }
    let serv = service(url + "/Controllers", "Product");
    let data = await serv.get("");
    return data;
}

async function getItems() {
    if (isCalled) {
        return apis;
    }
    let serv = service(url + "/CoinEquipments", "");
    let data = await serv.get("");
    return data;
}
async function getItemsbyId(id) {
    if (isCalled) {
        return apis;
    }
    let serv = service(url + "/CoinEquipments", "");
    let data = await serv.get(id);
    return data;
}

async function getEquipments() {
    if (isCalled) {
        return apis;
    }
    let serv = service(url, "Equipments");
    let data = await serv.get();
    return data;
}

async function getPetSkills() {
    if (isCalled) {
        return apis;
    }
    let serv = service(url, "PetSkills");
    let data = await serv.get();
    return data;
}

async function getEquipmentsbyId(id) {
    if (isCalled) {
        return apis;
    }
    let serv = service(url + "/Equipments", "");
    let data = await serv.get(id);
    return data;
}

/*

 */
async function getMatchMakingRank(seasonid, eventType, filter, skip, limit) {
    let page = skip || 0
    let pageSize = limit || 10
    const id = `season/${seasonid}/${eventType}/${page}/${pageSize}/${filter}`
    let serv = service(url + "/Tops", "MatchMakingRank");
    let data = await serv.get(id);
    return data;
}

async function getNotifications() {
    if (isCalled) {
        return apis;
    }
    let serv = service(url, "Notifications");
    let data = await serv.get();
    let res = [];
    for (const notif of data) {
        if (notExpired(notif.schedule.start, notif.schedule.end)) {
            res.push(notif)
        }
    }
    return res;
}

async function getMailDescriptions() {
    if (isCalled) {
        return apis;
    }
    let serv = service(url, "MailDescriptions");
    let data = await serv.get();
    let res = [];
    for (const item of data) {
        if (item.isDeleted == false) {
            res.push(item)
        }
    }
    return res;
}
function notExpired(startDate, endDate) {
    const currentDate = new Date()
    const start = new Date(startDate);
    const end = new Date(endDate);
    return currentDate >= start && currentDate <= end;
}

function getRandomHexColor() {
    return `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
}



async function getGoldEco() {
    if (isCalled) {
        return apis;
    }

    let data = []
    let chartData = {}
    let regions = await this.getRegions()
    for (const region of Object.keys(regions)) {
        let name = region
        chartData = {}
        chartData.datasets = []
        chartData.labels = []
        let dt = {
            label: "1B Gold",
            data: [],
            backgroundColor: []
        }
        try {
            let servers = await regions[region].servers.getServers()
            if (servers) {
                for (const server of servers) {
                    let count = 0;
                    chartData.labels.push(server.name)
                    try {
                        let res = await regions[region].charequipment.getGoldEconomy(server._id)
                        count = res.count
                    } catch (error) {
                        count = 0
                    }
                    dt.data.push(count)
                    dt.backgroundColor.push(getRandomHexColor())
                }
                chartData.datasets.push(dt)
            }
        } catch (error) {
            console.log("cant find server")
        }
        data.push({ name: name, chartData: chartData })
    }
    return data;
}

export const api = {
    getRegions,
    getProducts,
    getItems,
    getItemsbyId,
    getEquipments,
    getEquipmentsbyId,
    getMatchMakingRank,
    getNotifications,
    getGoldEco,
    getPetSkills,
    getMailDescriptions
}